import { getDepartmentById } from '../api/modules/department';
import { normalizeDeptId, resolveActiveSchoolId } from '../utils/deptCascaderProps';

/**
 * 根据顶栏学校部门 Id 解析 SchType，判断是否为钉钉学校。最后更新：2026-10-19
 */
export default {
  data() {
    return {
      currentSchoolSchType: ''
    };
  },
  computed: {
    isDingTalkSchool() {
      return String(this.currentSchoolSchType || '').toLowerCase() === 'dingding';
    }
  },
  methods: {
    /**
     * 加载当前学校 SchType。学校 Id 保持字符串，避免雪花截断。
     * @param {string|number} [schoolDepartmentId]
     */
    async loadCurrentSchoolSchType(schoolDepartmentId) {
      const schoolId = normalizeDeptId(schoolDepartmentId) || resolveActiveSchoolId(this);
      if (!schoolId) {
        this.currentSchoolSchType = '';
        return;
      }
      try {
        const res = await getDepartmentById(schoolId);
        const dept = (res.data && res.data.response) || {};
        this.currentSchoolSchType = dept.SchType || dept.schType || '';
      } catch (e) {
        this.currentSchoolSchType = '';
      }
    }
  }
};
